$(function() {
  $('.read-more-toggler')
    .off('click')
    .on('click', onClickReadMoreButton);
  $('.read-more-toggler').each(function() {
    initReadMoreToggler($(this));
  });
});

function getReadMoreContainers($target) {
  return $target.parents('.read-more-text').addBack().filter('.read-more-text');
}

function initReadMoreToggler($button) {
  var $target = $($button.data('target'));
  if (!$target.length) {
    return;
  }

  var $containers = getReadMoreContainers($target);
  var closedH = $target.outerHeight();

  $containers.addClass('open');
  var openenedH = $target[0] ? $target[0].scrollHeight : $target.outerHeight();
  $containers.removeClass('open');

  if (!openenedH || closedH >= openenedH) {
    $button.remove();
  }
}
function onClickReadMoreButton(e) {
  e.preventDefault();
  var $button = $(this);
  var $target = $($button.data('target'));
  if (!$target.length) {
    return;
  }

  var $containers = getReadMoreContainers($target);

  $containers.toggleClass('open');

  if ($target.hasClass('open')) {
    $button.text($button.data('openText'));
  } else {
    $button.text($button.data('closedText'));
  }
  $('html, body').animate({ scrollTop: $target.offset().top - 100 }, 500);
}
